export enum AuthorisationValueEnum {
  FirstChoice = 0,
  SecondChoice = 1,
  ThirdChoice = 2,
}
